import { Chip, Divider, FormControl, Grid, IconButton, InputLabel, LinearProgress, Paper, TextField, Typography } from '@mui/material';
import React, { Fragment, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { faCheckCircle, faClock, faBan, faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataGrid } from '@mui/x-data-grid';
import { CustomNoRowsOverlay } from '../../../components/grid-overlay/GridOverlay';
import { useState } from 'react';
import { CommonDialogBox } from '../../../components/DialogBox/CommonDialogBox';
import { envelopeUpdateSigner, getEnvelope } from '../../../api/envelopeApi';
import Notification from '../../../components/Notification';
import { regx } from '../../../constants/constants';
import { useParams } from 'react-router-dom';
import { addUpdateRecipientList } from './envelopeSlice';

let signedStatus = null;

const RecipientsList = () => {
   const { id: envId } = useParams();
   const dispatch = useDispatch();
   const [data, setData] = useState([]);
   const [focusCard, setFocusCard] = useState(null);
   const [error, setError] = useState(null);
   const clearFocusCard = useRef(null);
   const valid = useSelector(state => state.user.valid);
   const envelope = useSelector((state) => state.envelope.entity);
   const envelopeId = envelope['id'];
   const envelopeCard = useSelector(state => state.envelope.cards);
   const [notify, setNotify] = useState({ open: false, message: '', severity: '', delay: 3000 });
   const [recipientFormList, setRecipientFormList] = useState(null);
   const [editFormBox, setEditFormBox] = useState({
      open: false,
      title: "Edit Recipient details",
      createButtons: [
         { btnText: 'Close', btnFun: 'cancel', variant: 'outlined', btnVisible: true, disabled: false },
         { btnText: 'Save', btnFun: 'confirm', variant: 'contained', btnVisible: true, disabled: false }
      ],
      actionButtonVisible: true,
      type: 'editFormBox'
   });

   const columns = [
      {
         field: 'name', headerName: 'Recipient', maxWidth: 150, flex: 4, renderCell: (params) => (
            <Typography variant="subtitle" color="text.primary" sx={{ fontWeight: '700' }}>{`${params.row.firstName} ${params.row.lastName}`}</Typography>
         )
      },
      {
         field: 'email', headerName: 'Email Id', maxWidth: 300, flex: 4
      },
      {
         field: 'roleName', headerName: 'Role', maxWidth: 250, flex: 2, renderCell: (params) => (
            <Chip label={params.value} color="info" variant="outlined" sx={{ minWidth: 100, textAlign: 'left' }} />
         )
      },
      {
         field: 'routingOrder', headerName: 'Routing Order', maxWidth: 150, flex: 2, renderCell: (params) => {
            if (params.row.applicableDocuments === 0 || ['editor', 'owner/editor', 'carboncopy'].includes(params.row.roleName.toLowerCase())) {
               return '--';
            }
         }
      },
      {
         field: 'consented', headerName: 'Consents', maxWidth: 150, flex: 3, renderCell: (params) => {
            if (params.row.applicableConsentForms === 0 || ['editor', 'owner/editor', 'carboncopy'].includes(params.row.roleName.toLowerCase())) {
               return '--';
            }

            if (params.row.applicableConsentForms === params.row.consented) {
               return <Chip icon={<FontAwesomeIcon icon={faCheckCircle} size="xl" />} label={`Complete`} color="success" variant="outlined" />
            }

            return (
               <Chip icon={<FontAwesomeIcon icon={faClock} size="xl" />}
                  label={`${params.row.applicableConsentForms - params.row.consented} of ${params.row.applicableConsentForms} pending`} color="warning" variant="outlined" />
            )
         }
      },
      {
         field: 'signed', headerName: 'Signatures', maxWidth: 200, flex: 3, renderCell: (params) => {

            if (params.row.applicableDocuments === 0 || ['editor', 'owner/editor', 'carboncopy'].includes(params.row.roleName.toLowerCase())) {
               return '--';
            }

            if (params.row.applicableDocuments === params.row.signed) {
               return <Chip icon={<FontAwesomeIcon icon={faCheckCircle} size="xl" />} label="Complete" color="success" variant="outlined" />
            }

            if (params.row.status === "Declined") {
               return <Chip icon={<FontAwesomeIcon icon={faBan} size="xl" />} label="Declined" color="error" variant="outlined" />
            }

            return (
               <Chip icon={<FontAwesomeIcon icon={faClock} size="xl" />}
                  label={`${params.row.applicableDocuments - params.row.signed} of ${params.row.applicableDocuments} pending`} color="warning" variant="outlined" />
            )
         }
      },
      {
         field: 'edit', headerName: '', maxWidth: 100, flex: 3, align: "center", hide: !valid, renderCell: (params) => {
            if (valid && ['signer'].includes(params.row.roleName.toLowerCase()) && params.row.signed == 0) {
               return <IconButton onClick={() => handleEdit(params.row)} aria-label="edit" className="edit-button" sx={{ '&.edit-button *, &.edit-button': { cursor: 'pointer' } }}><FontAwesomeIcon icon={faPencil} size="xs" /></IconButton>
            }

            return '--'
         }
      }
      /* ,{
         field: 'uploaded', headerName: 'Signer Attachments', minWidth: 100, flex: 3, renderCell: (params) => {
            if (params.row.applicableSignerAttachments === 0) {
               return '--';
            }
   
            if (params.row.Signatures === params.row.signed) {
               return <Chip icon={<FontAwesomeIcon icon={faCheckCircle} size="xl" />} label={`Complete`} color="success" variant="outlined" />
            }
   
            return (
               <Chip icon={<FontAwesomeIcon icon={faClock} size="xl" />}
                  label={`${params.row.applicableSignerAttachments - params.row.uploaded} of ${params.row.applicableSignerAttachments} pending`} color="warning" variant="outlined" />
            )
         }
      } */
   ];

   const handleClose = (event, reason) => {
      if (reason === 'clickaway') return;
      setEditFormBox({ ...editFormBox, open: false });
      setRecipientFormList(null);
      setError(null)
   };

   const handleNofityClose = (event, reason) => {
      if (reason === 'clickaway') return;
      setNotify({ ...notify, open: false });
   };

   const handleEdit = (row) => {
      const updateData = data.filter(item => item.email === row.email).map(({ id, firstName, lastName, middleName, email, routingOrder }) => ({ id, firstName, lastName, middleName, email, routingOrder }));

      setRecipientFormList(updateData);
      setEditFormBox(prevState => ({ ...prevState, open: true }));

      // Dynamically create an error array based on custom length
      setError(Array(3).fill({ text: null, valid: false }));
   };

   const handleChange = (e, i, index) => {
      const { name, value } = e.target;
      const updatedList = [...recipientFormList];
      updatedList[i] = { ...updatedList[i], [name]: value };
      setRecipientFormList(updatedList);
      validateField(name, index - 1, value, updatedList);
   };

   const handleSave = async () => {
      const { id, ...recipientData } = recipientFormList[0]; // Remove 'id' without mutation
      const data = { recipient: recipientData };
      const checkRecipientExisting = envelope['recipients'].filter(item => item.id == id).some(item => item.email.toLowerCase() === recipientData.email.toLowerCase())

      if (checkRecipientExisting) {
         setNotify(prevState => ({ ...prevState, open: true, message: "Email id already existing!.", severity: 'error' }));
         return
      }
      // Disable buttons before API call
      setEditFormBox(prevState => ({
         ...prevState,
         createButtons: prevState.createButtons.map(button => ({ ...button, disabled: true }))
      }));

      const respo = await envelopeUpdateSigner(envelopeId, data);

      if (respo?.status) {
         setNotify(prevState => ({ ...prevState, open: true, message: 'Details updated successfully!', severity: 'success' }));
         getEnvelope(envId).then(data => {
            dispatch(addUpdateRecipientList(data));
         })
         setEditFormBox(prevState => ({
            ...prevState,
            open: false,
            createButtons: prevState.createButtons.map(button => ({ ...button, disabled: false }))
         }));
         handleClose();
      }
      else {
         setNotify(prevState => ({ ...prevState, open: true, message: "Request failed. Please try again later.", severity: 'error' }));

         // Re-enable buttons in case of failure
         setEditFormBox(prevState => ({
            ...prevState,
            createButtons: prevState.createButtons.map(button => ({ ...button, disabled: false }))
         }));
      }
   };

   useEffect(() => {
      if (envelopeCard.payload) {
         clearFocusCard.current = setTimeout(() => {
            setFocusCard(envelopeCard.payload, clearTimeout(clearFocusCard.current))
         }, 500);
      }
   }, [envelopeCard.payload])

   useEffect(() => {
      if (!envelope || envelope.recipients?.length === 0) return;

      const records = envelope.recipients.map(r => {
         const consents = envelope.consentForms.filter(cf => cf.consents.some(c => c.recipientId === r.id)).map(cf => cf.consents.find(c => c.recipientId === r.id));

         const documents = envelope.documents.filter(cf => cf.signatures.some(c => c.recipientId === r.id)).map(cf => cf.signatures.find(c => c.recipientId === r.id));

         signedStatus = documents.filter(c => c.statusName === "Signed").length;

         return {
            ...r,
            applicableConsentForms: consents.length,
            consented: consents.filter(c => c.statusName === "Consented").length,
            applicableDocuments: documents.length,
            signed: documents.filter(c => c.statusName === "Signed").length,
            applicableSignerAttachments: envelope.signerAttachments?.length || 0,
            uploaded: envelope.signerAttachments?.filter(sa => sa.fileName)?.length || 0,
            status: documents[0]?.statusName || '-'
         }
      });

      const ownerData = {
         id: envelope.id,
         firstName: envelope.ownerName.split(" ")[0],
         lastName: envelope.ownerName.split(" ")[1],
         email: envelope.ownerEmail,
         roleName: "Owner/Editor",
         signed: signedStatus
      };

      setData([...records, ownerData]);
   }, [envelope]);

   const label = (value) => {
      let text = '';
      switch (value) {
         case 'firstName':
            text = 'First Name'
            break;
         case 'lastName':
            text = 'Last Name'
            break;
         case 'email':
            text = 'Email Id'
            break;
         default:
            text = ''
      }
      return text
   }

   const validateField = (name, index, value, list) => {
      let errorMessage = "";
      let isValid = false;

      if (!value.trim()) {
         errorMessage = "Field is required!";
         isValid = true;
      } else if (["firstName", "lastName"].includes(name) && !regx.characters.test(value)) {
         errorMessage = "Please enter only characters";
         isValid = true;
      } else if (name === "email" && !regx.emailFormat.test(value)) {
         errorMessage = "Please enter a valid email ID";
         isValid = true;
      }

      setError(prevError => {
         const updatedErrors = [...prevError];
         updatedErrors[index] = { text: errorMessage || null, valid: isValid };
         return updatedErrors;
      });

      toggleCreateButton(list);
   };

   const toggleCreateButton = (list) => {
      const isInvalid = list.some(item => !item.firstName.trim() || !item.lastName.trim() || !item.email.trim() || !regx.emailFormat.test(item.email) || !regx.characters.test(item.firstName) || !regx.characters.test(item.lastName)
      );

      setEditFormBox(prevState => ({
         ...prevState,
         createButtons: [
            { ...prevState.createButtons[0] },
            { ...prevState.createButtons[1], disabled: isInvalid }
         ]
      }));
   };

   return (
      <Paper sx={{ mt: 2, height: 375, width: '100%' }} elevation={focusCard ? 2 : 0}>
         {notify.open && <Notification open={notify.open} message={notify.message} delay={notify.delay} onClose={handleNofityClose} severity={notify.severity} />}
         <DataGrid
            autoheight
            components={{
               NoRowsOverlay: CustomNoRowsOverlay,
               LoadingOverlay: LinearProgress
            }}
            rows={data.map((row, index) => ({ ...row, id: index }))}
            columns={columns}
            onRowClick={() => { }}
            sx={{
               borderColor: focusCard ? 'primary.light' : '',
               '& .MuiDataGrid-cell, & .MuiDataGrid-cell *': {
                  cursor: 'default'
               },
               "& .MuiDataGrid-container--top::after": {
                  background: 'none',
                  borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
               },
               "& .MuiDataGrid-container--top [role=row]": {
                  background: '#fff'
               },
               "& .MuiDataGrid-columnSeparator": {
                  visibility: 'visible'
               },
               "& .MuiDataGrid-footerContainer": {
                  border: data.length > 5 && 'none'
               },
               "& .MuiDataGrid-row:last-child .MuiDataGrid-cell": {
                  borderBottom: data.length > 5 && '1px solid var(--rowBorderColor)'
               }
            }}
         />
         {editFormBox.open && <CommonDialogBox dialog={editFormBox} handleClick={handleSave} customProps={{ fullWidth: true, maxWidth: "md", open: editFormBox.open, className: 'editForm common-dialog', disableEscapeKeyDown: true, onClose: handleClose, onBackdropClick: handleClose }}>
            {recipientFormList.map((list, i, self) =>
               <Fragment key={`self-${i}`}>
                  <Grid container spacing={2}>
                     {Object.keys(list).map((item, index) => ['firstName', 'lastName', 'email'].includes(item) && <Grid key={`${item}-${index}`} item xs={4}>
                        <FormControl variant="standard" className="formControl" sx={{ display: 'block' }}>
                           <InputLabel htmlFor={item}>{label(item)}</InputLabel>
                           <TextField id={item} name={item} sx={{ '& .MuiInputBase-formControl': { color: 'var(--dark-black)', fontWeight: 500, backgroundColor: 'var(--white)' }, '& .Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--error-main)' }, '& .Mui-error.MuiFormHelperText-root': { color: 'var(--error-main)', fontWeight: 500 } }} className="formInput" onChange={(e) => handleChange(e, i, index)} value={list[item]} size="small" error={error[index - 1] && error[index - 1]?.valid} helperText={error[index - 1]?.text} />
                        </FormControl>
                     </Grid>)}
                  </Grid>
                  {self.length > 1 && i == 0 && <Divider sx={{ mt: 2, mb: 2 }} />}
               </Fragment>
            )}
         </CommonDialogBox>}
      </Paper>
   );
}

export default RecipientsList;
